import { useTranslation } from 'next-i18next';
import { formatNumericValue } from 'utils/general';

import IconWithTitleDescription from '@/shared/components/atoms/IconWithTItleDescription';
import { IIconWithTitleDescriptionProps } from '@/shared/components/atoms/IconWithTItleDescription/IconWithTitleDescription';

const CollapsedContractUnit: React.FC<{
  unitName: string;
  unitPrice: number;
  currency?: string;
}> = ({ unitName, unitPrice, currency }) => {
  const { t } = useTranslation();

  const items: IIconWithTitleDescriptionProps[] = [
    {
      title: t('unit-type'),
      description: unitName,
    },
    {
      title: t('unit-value'),
      description: `${formatNumericValue(unitPrice)}${
        currency ? ` ${t(currency)}` : ''
      }`,
    },
  ];

  return (
    <div className='grid grid-cols-2 gap-16 border-t-xs border-t-neutralVariant-90 py-16 px-24'>
      {items.map((item) => (
        <IconWithTitleDescription
          key={item.title}
          item={{
            ...item,
            titleTypography: {
              className: 'text-surface-10',
              variant: 'subtitle2',
            },
          }}
        />
      ))}
    </div>
  );
};

export default CollapsedContractUnit;
